export default __webpack_public_path__ + "static/DINPro-Light-a6f32c9987a7c6f66b3594dc2f8ba003.otf";